import React from "react"
import { connect } from "react-redux"
import { Formik } from "formik"

import {
  invalidateReprocessSearchDispatchAction
} from "../../../../state/product/dispatchActions"
import {
  ADVANCED_SEARCH_SCOPE_CONFIGURATION_FIELDS as SCOPE_CONFIGURATION_FIELDS,
  getMissionDataByCodes,
  getMissionDescriptionsByCodes,
} from "../../../../helpers/configurationHelper"
import {
  extractFiltersBy,
  extractFinalValues,
  getInitialValueFromConfiguration,
  validateValuesFromConfiguration,
} from "../../../../helpers/dynamicFormHelper"
import {
  getMainInputConfigurationsBy,
} from "../../../../helpers/searchHelper"
import { AdvancedSearchConfigurationsType } from "../../../../types/configurations"
import { ShapeType } from "../../../../types/shape"
import { ProductImageStacType } from "../../../../types/product"
import { AppParametersType } from "../../../../types/app"
import InvalidationForm from "./InvalidationForm";

interface PropsType {
  configurations: AdvancedSearchConfigurationsType;
  isInterferometricStackSearch: boolean;
  lastShape: ShapeType;
  loadingInitialData: boolean;
  formData: any;
  selectedProducts: ProductImageStacType[];
  searchDispatchActionHandler: any;
  appParameters: AppParametersType;
  searchByProducts: any;
  searchProductIds: string;
}

const InvalidationFormContainer = (props: PropsType) => {
  const {
    configurations,
    lastShape,
    loadingInitialData,
    selectedProducts,
    searchDispatchActionHandler,
    appParameters,
    searchByProducts
  } = props

  const mainInputConfigurations = getMainInputConfigurationsBy(configurations, appParameters)

  const onSubmitHandler = (formValues, actions) => {

    const values: any = extractFinalValues(
      mainInputConfigurations,
      configurations,
      appParameters,
      SCOPE_CONFIGURATION_FIELDS,
      lastShape,
      formValues
    )

    const dataToSend: any = {
      invalidate_search: true,
      missions: getMissionDescriptionsByCodes(configurations, values.missions),
      indexes: getMissionDataByCodes(configurations, values.missions, values.dataset),
      from: values.date1,
      to: values.date2,
      invalidate_mode: values.invalidate_mode,
      routine: true,
    }

    if (values.missions.length > 0 || searchByProducts) {
      dataToSend.filters = extractFiltersBy(
        configurations,
        appParameters,
        mainInputConfigurations,
        SCOPE_CONFIGURATION_FIELDS,
        values
      )
    }

    searchDispatchActionHandler(
      dataToSend,
      appParameters.language
    ).then((response) => {
      actions.setSubmitting(false)
    })

    return new Promise((a, b) => {}) // to prevent from isSubmitting issue
  }

  const initialValues = getInitialValueFromConfiguration(mainInputConfigurations, configurations, appParameters, SCOPE_CONFIGURATION_FIELDS, lastShape);
  const validateValues = validateValuesFromConfiguration(mainInputConfigurations, configurations, appParameters, SCOPE_CONFIGURATION_FIELDS, lastShape, appParameters.language, searchByProducts);

  return (
    <Formik
      initialValues={initialValues}
      validate={validateValues}
      onSubmit={onSubmitHandler}
    >
      {(formProps) => (
        <InvalidationForm
          mainInputConfigurations={mainInputConfigurations}
          configurations={configurations}
          lastShape={lastShape}
          selectedProducts={selectedProducts}
          loadingInitialData={loadingInitialData}
          formProps={formProps}
        />
      )}
    </Formik>
  )
}

const mapStateToProps = (state) => ({
  appParameters: state.application.appParameters,
  lastShape: state.geoMap.lastShape,
  loadingInitialData: state.application.loadingInitialData,
  formData: state.application.formData,
  selectedProducts: state.product.selectedProducts,
  searchByProducts: state.geoMap.searchByProducts,
  searchProductIds: state.geoMap.searchProductIds,
})

const mapDispatchToState = (dispatch) => ({
  searchDispatchActionHandler: (
    formData,
    language
  ) => dispatch(
      invalidateReprocessSearchDispatchAction(
      formData,
      language,
    )
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToState
)(InvalidationFormContainer)
